import { createCalmPublicApi } from '@rhg/libs/api/create-calm-public-api';
import { queryKeys, useQuery } from '@rhg/libs/react-query';

export function useDeviceConsent() {
    const { data, ...otherProps } = useQuery({
        queryKey: [queryKeys.deviceConsent],
        queryFn: async () => {
            const calmPublicApi = createCalmPublicApi();

            const response = await calmPublicApi.getCalmPublicDeviceConsent();

            return response.data;
        },
        staleTime: 1000 * 60 * 60 * 8, // 8 hours
    });
    return {
        deviceConsent: data,
        ...otherProps,
    };
}
